import type { ObjecttypeDto } from 'cadenza/api-client/dto/objecttype-dto';

// This file is meant for generic acquisition layer utilities, which are independent of a workbook redux store
// and thus can be used not only in a workbook, but for example also in the management center.
// To have access to the workbook redux store, please use workbook-attribute-util.

/**
 * SRS used for geometries encoded in GeoJson. Despite being the standard by spec Cadenza in other
 * places encode geometries in a different SRS.
 * This might be made the standard for Cadenza as well in the near future.
 *
 * @see https://datatracker.ietf.org/doc/html/rfc7946#section-4
 */
export const GEO_JSON_SRS = 'EPSG:4326';
export const OL_DEFAULT_MAP_SRS = 'EPSG:3857';

export function isTemplateObjecttype (objecttype: ObjecttypeDto) {
  return objecttype.properties?.['is-acquisition-template'] === 'true';
}

export function isAcquisitionObjecttype (objecttype: ObjecttypeDto) {
  // Acquisition OTs have a source OT defined
  return !!objecttype.properties?.['source-acquisition-template'];
}
